import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach(() => {
  const container = document.querySelector('.layout-page__overflow');
  if (container) container.scrollTop = 0;
});

export default router;
